import styled from 'styled-components';

export const IncrementerGroup = styled.div`
    display: flex;
    flex-direction: row;
    gap: 30px;
    margin-bottom: 47px;
`;
